<template>
  <div v-if="!showAddGoodieComponent && !showEditGoodieComponent">
    <div v-if="data">
      <h1>Goodies for {{ data.code }}</h1>
      <div style="overflow-x: auto;">
        <table v-if="data.goodies && data.goodies.length > 0" class="table table-sm table-striped">
          <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Capacity</th>
            <th>Visible</th>
            <th>Action</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="goodie in data.goodies" :key="goodie.id">
            <td>{{ goodie.name }}</td>
            <td>{{ goodie.description }}</td>
            <td>{{ goodie.capacity }}</td>
            <td>
              <input type="checkbox" v-model="goodie.visible_for_user"
                     @change="updateGoodieVisibility(goodie.id, $event.target.checked)">
            </td>
            <td>
              <button class="btn btn-primary btn-sm me-2" @click="editGoodie(goodie)">
                <i class="fas fa-pen"></i>
              </button>
              <button class="btn btn-danger btn-sm" @click="confirmDelete(goodie)">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <button class="btn btn-primary mb-3" @click="showAddGoodieComponent=true">Add goodie</button>
    </div>
    <div v-else>
      <h1>Goodies</h1>
      <p>Loading...</p>
    </div>
  </div>
  <div v-if="showAddGoodieComponent">
    <OrganisationGoodieAdd :organisation=data @close="handleCloseAdd"/>
  </div>
  <div v-if="showEditGoodieComponent">
    <OrganisationGoodieEdit :organisation=data :goodie=selectedGoodie @close="handleCloseEdit"/>
  </div>
</template>

<script>
import OrgansiationGoodieAdd from "@/components/OrganisationGoodieAdd.vue";
import {API_BASE_URL} from "@/config";
import {getCSRFToken} from "@/store/auth";
import OrganisationGoodieEdit from "@/components/OrganisationGoodieEdit.vue";

export default {
  name: "OrganisationGoodiesAdmin",
  components: {OrganisationGoodieEdit, OrganisationGoodieAdd: OrgansiationGoodieAdd},
  data() {
    return {
      data: null,
      showAddGoodieComponent: false,
      showEditGoodieComponent: false,
      selectedGoodie: null,
    }
  },
  mounted() {
    this.fetchOrganisationGoodiesDetails();
  },
  methods: {
    async fetchOrganisationGoodiesDetails() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/goodies/admin`, {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          const data = await response.json();
          this.data = data;
          document.title = `${this.data.code} - Goodies Admin`;
        }
      } catch (error) {
        console.error('Error fetching organisation goodies details:', error);
      }
    },
    confirmDelete(goodie) {
      if (window.confirm(`Are you sure you want to delete goodie "${goodie.name}"?`)) {
        this.delete_goodie(goodie.id);
      }
    },
    async delete_goodie(goodie_id) {
      try {
        const response = await fetch(
            `${API_BASE_URL}/goodies/${goodie_id}`, {
              method: 'DELETE',
              credentials: 'include',
              headers: {
                'X-CSRFToken': getCSRFToken(),
              },
            });
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          await this.fetchOrganisationGoodiesDetails();
        }
      } catch (error) {
        console.error('Error deleting goodie:', error);
      }
    },
    async updateGoodieVisibility(goodieId, isVisible) {
      try {
        const response = await fetch(
            `${API_BASE_URL}/goodies/${goodieId}`, {
              method: 'PATCH',
              credentials: 'include',
              headers: {
                'X-CSRFToken': getCSRFToken(),
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({visible_for_user: isVisible})
            });
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          await this.fetchOrganisationGoodiesDetails();
        }
      } catch (error) {
        console.error('Error updating goodie visibility:', error);
      }
    },
    editGoodie(goodie) {
      this.selectedGoodie = goodie;
      this.showEditGoodieComponent = true;
    },
    handleCloseAdd() {
      this.showAddGoodieComponent = false;
      this.fetchOrganisationGoodiesDetails();
    },
    handleCloseEdit() {
      this.showEditGoodieComponent = false;
      this.fetchOrganisationGoodiesDetails();
    }
  }
}
</script>
